import metadata from 'scoreboard/components/metadata'
import _ from 'lodash'

// returns true if an org must be chosen before going to the section
function requiresOrg(section) {
	return section && !!_.get(metadata[section], 'requiresOrg')
}

export default requiresOrg

requiresOrg.__filename__ = 'components/requires-org.js'
